import styled from 'styled-components';
import { rem } from 'polished';

const FieldContainer = styled.div`
    padding-bottom:  ${({ paddingBottom }) =>
    paddingBottom !== undefined && paddingBottom !== null ? `${rem(paddingBottom)}` : `${rem(16)}`};
`;

export default FieldContainer;
